import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import LandingPage from "./pages/LandingPage";
import OptionA from "./pages/OptionA";
import OptionD from "./pages/OptionD";
import OptionACompact from "./pages/OptionACompact";
import AuthenticationPage from "./pages/AuthenticationPage";
import QuestionnairePage from "./pages/QuestionnairePage";
import SchoolReportPage from "./pages/SchoolReportPage";
import ResultsReportMockup from "./pages/ResultsReportMockup";
import AdaptedReportPage from "./pages/AdaptedReportPage";
import ContributePage from "./pages/ContributePage";
import ParentLogin from "./pages/ParentLogin";
import ParentDashboard from "./pages/ParentDashboard";
import ChooseReportPage from "./pages/ChooseReportPage";
import ParentReportPage from "./pages/ParentReportPage";
import MatchWarningPage from "./pages/MatchWarningPage";
import AdminFeedbackPage from "./pages/AdminFeedbackPage";
import AdminSchoolFeedbackPage from "./pages/AdminSchoolFeedbackPage";
import AdminMigrationsPage from "./pages/AdminMigrationsPage";
import AdminSchoolsPage from "./pages/AdminSchoolsPage";
import SubmitReviewPage from "./pages/SubmitReviewPage";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<OptionACompact />} />
          <Route path="/auth" element={<AuthenticationPage />} />
          <Route path="/questionnaire" element={<QuestionnairePage />} />
          <Route path="/results" element={<SchoolReportPage />} />
          <Route path="/contribute" element={<ContributePage />} />
          <Route path="/report-mockup" element={<ResultsReportMockup />} />
          <Route path="/report-old" element={<AdaptedReportPage />} />
          <Route path="/option-a" element={<OptionA />} />
          <Route path="/option-d" element={<OptionD />} />
          <Route path="/old" element={<LandingPage />} />
          
          {/* Parent Dashboard Routes */}
          <Route path="/parent-login" element={<ParentLogin />} />
          <Route path="/parent-dashboard" element={<ParentDashboard />} />
          <Route path="/choose-report" element={<ChooseReportPage />} />
          <Route path="/parent-report/:reportId" element={<ParentReportPage />} />
          <Route path="/match-warning/:reportId" element={<MatchWarningPage />} />
          
          {/* Admin Routes */}
          <Route path="/admin/feedback" element={<AdminFeedbackPage />} />
          <Route path="/admin/school-feedback" element={<AdminSchoolFeedbackPage />} />
          <Route path="/admin/migrations" element={<AdminMigrationsPage />} />
          <Route path="/admin/schools" element={<AdminSchoolsPage />} />

          {/* Public review submission (no login) */}
          <Route path="/submit-review" element={<SubmitReviewPage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
